import React from 'react';
import { TrendingUp } from 'lucide-react';
import { StatsOverview } from '../StatsOverview';
import { PersonalizedTooltip } from '@/components/personalization/PersonalizedTooltip';

export const MetricsSection: React.FC = () => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <PersonalizedTooltip 
          content="These are your most important metrics based on your fitness goals"
          side="right"
        >
          <h2 className="text-xl font-semibold text-foreground flex items-center gap-2">
            <TrendingUp className="h-5 w-5" />
            Key Metrics
          </h2>
        </PersonalizedTooltip>
        <p className="text-sm text-muted-foreground">Track your progress trends</p>
      </div>
      <StatsOverview />
    </div>
  );
};